export default "__VITE_ASSET__CmrL7FwX__"